import { instance } from '../helper/api'

export const getInfoByUser = async email => {
  let resultData = {}
  const axiosConfig = {
    url: `/v1/customer/info/by-user/?user=${email}&limit=100`,
    method: 'GET'
  }

  try {
    const results = await instance.request(axiosConfig)
    resultData = results.data
  } catch (error) {
    if (error.response) {
      return error.response.data
    } else {
      return error.message
    }
  }

  return resultData
}

export const getDepartmentsByUser = async email => {
  let resultData = {}
  const axiosConfig = {
    url: `/v1/customer/department/by-user/?user=${email}&limit=100`,
    method: 'GET'
  }

  try {
    const results = await instance.request(axiosConfig)
    resultData = results.data
  } catch (error) {
    if (error.response) {
      return error.response.data
    } else {
      return error.message
    }
  }

  return resultData
}

export const getCostCentersByUser = async email => {
  let resultData = {}
  const axiosConfig = {
    url: `/v1/customer/cost-center/by-user/?user=${email}&limit=100`,
    method: 'GET'
  }

  try {
    const results = await instance.request(axiosConfig)
    resultData = results.data
  } catch (error) {
    if (error.response) {
      return error.response.data
    } else {
      return error.message
    }
  }

  return resultData
}

export const getGLAccountsByUser = async email => {
  let resultData = {}
  const axiosConfig = {
    url: `/v1/customer/general-ledger-account/by-user/?user=${email}&limit=100`,
    method: 'GET'
  }

  try {
    const results = await instance.request(axiosConfig)
    resultData = results.data
  } catch (error) {
    if (error.response) {
      return error.response.data
    } else {
      return error.message
    }
  }

  return resultData
}

export const signIn = async data => {
  let resultData = {}
  const axiosConfig = {
    url: '/v1/customer/sign-in/',
    method: 'POST',
    data: data
  }

  try {
    const results = await instance.request(axiosConfig)
    resultData = results.data
  } catch (error) {
    if (error.response) {
      return error.response.data
    } else {
      return error.message
    }
  }

  return resultData
}

export const getProfile = async () => {
  let resultData = {}
  const axiosConfig = {
    url: '/v1/customer/profile/',
    method: 'GET'
  }

  try {
    const results = await instance.request(axiosConfig)
    resultData = results.data.data
  } catch (error) {
    if (error.response) {
      return error.response.data
    } else {
      return error.message
    }
  }

  return resultData
}

export const getProfileDetail = async () => {
  let resultData = {}
  const axiosConfig = {
    url: '/v1/customer/profile/',
    method: 'GET'
  }

  try {
    const results = await instance.request(axiosConfig)
    resultData = results.data
  } catch (error) {
    if (error.response) {
      return error.response.data
    } else {
      return error.message
    }
  }

  return resultData
}

export const signUp = async data => {
  let resultData = {}
  const axiosConfig = {
    url: '/v1/customer/sign-up/',
    method: 'POST',
    data: data
  }

  try {
    const results = await instance.request(axiosConfig)
    resultData = results.data
  } catch (error) {
    if (error.response) {
      return error.response.data
    } else {
      return error.message
    }
  }

  return resultData
}

export const updateProfile = async data => {
  let resultData = {}
  const axiosConfig = {
    url: '/v1/customer/profile/',
    method: 'PATCH',
    data: data
  }

  try {
    const results = await instance.request(axiosConfig)
    resultData = results.data
  } catch (error) {
    if (error.response) {
      return error.response.data
    } else {
      return error.message
    }
  }

  return resultData
}

export const updateProfilePicture = async data => {
  let resultData = {}
  const axiosConfig = {
    url: '/v1/customer/profile/picture/',
    method: 'PATCH',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: data
  }

  try {
    const results = await instance.request(axiosConfig)
    resultData = results.data
  } catch (error) {
    if (error.response) {
      return error.response.data
    } else {
      return error.message
    }
  }

  return resultData
}

export const updatePassword = async data => {
  let resultData = {}
  const axiosConfig = {
    url: '/v1/customer/profile/password/',
    method: 'PATCH',
    data: data
  }

  try {
    const results = await instance.request(axiosConfig)
    resultData = results.data
  } catch (error) {
    if (error.response) {
      return error.response.data
    } else {
      return error.message
    }
  }

  return resultData
}
